import { h } from 'preact';
import clsx from "clsx";

const Recommendations = ({ isEnabled, recommendedProducts }) => (
	<div>
		{
			isEnabled && (<div className="bg-grey-5 py-5.5 pl-3 md:pl-5.5">
				<div className="sr-only overflow-hidden" data-minicart-recommended-slider>
					<p className="utility-1-bold mb-5.5">best sellers</p>
					<div className="swiper-wrapper">
						{
							recommendedProducts.map((product) => (
								<div className="swiper-slide !h-auto !w-68.75" key={product.id}>
									<a className="text-primary no-underline flex gap-2" href={`/products/${product.handle}`}>
										{product?.images[0]?.src ? (
											<div className="group bg-grey-5">
												<img
													className={clsx("image object-cover mix-blend-darken mx-auto",
														product.images.length > 1 && "group-hover:hidden")}
													alt={product?.images[0]?.alt}
													src={product?.images[0]?.src}
													width="104"
													height="auto"
													srcSet={product?.images[0]?.srcSet}
													loading="lazy"
												/>
												{product.images.length > 1 && (
													<img
														className="hidden group-hover:block image object-cover mix-blend-darken mx-auto"
														alt={product?.images[1]?.alt}
														src={product?.images[1]?.src}
														width="104"
														height="auto"
														srcSet={product?.images[1]?.srcSet}
														loading="eager"
													/>
												)}
											</div>
										) : (
											<div
												className="[&>svg]:w-26"
												dangerouslySetInnerHTML={
													{__html: product.placeholder_svg}
												}
											/>
										)}
										<div className="flex flex-col">
											<p className="utility-2">{product.title}</p>
											<p className="utility-2">
												{product.price_varies && <span>from&nbsp;</span>}
												<span>{product.price.replace(".00", "")}</span>
											</p>
										</div>
									</a>
								</div>
							))
						}
					</div>
				</div>
			</div>)
		}

		<div data-minicart-recommendations-nosto></div>
	</div>
)

export default Recommendations;
